import { Injectable } from '@angular/core';
import { SesssionActivityService } from './sesssion-activity.service';

@Injectable({
  providedIn: 'root'
})
export class LearningStatusService {
  learingPercentage: any;
  projectButtonStatus: boolean;
  createProjectTooltip: string;

  constructor(
    private sesssionActivityService: SesssionActivityService,
  ) { }

  getLearningSatatus(id): void {
    this.sesssionActivityService.getLastSessionActiityPercentageByUserId(id).subscribe(
      resp => {
        this.learingPercentage = resp;
        if (this.learingPercentage.filingPercentage == "100") {
          this.projectButtonStatus = false;
          this.createProjectTooltip = "Create project";
        }
        else {
          this.projectButtonStatus = true;
          this.createProjectTooltip = "It will enable after complete the learning module";
        }
      }, error => {
        console.log(error);
      })
  }
}
